// SCENE CLOCK (scene cycle, "R20" in the briefs): a clock for scenes that play a
// script over a fixed cycle (a crossing, a season...), independent of the beat.
//
//   import { SceneClock } from './lib/scene-clock.js';
//   const clock = new SceneClock({ period: 40, start: 'random' });
//   clock.update(dt);            // every frame; dt = 0 (pause) freezes it
//   clock.t                      // seconds inside the current cycle, [0, period)
//   clock.phase                  // t / period, [0, 1)
//   clock.cycle                  // cycles begun since creation (0 for the first)
//   clock.wrapped                // true on the one frame a new cycle begins
//   clock.elapsed                // scene seconds since creation, start offset included
//
// start: 'random' (a phase drawn at creation: the scene never opens on the same
// moment) or a phase in [0, 1). A scene that must already be under way at the
// first frame chooses its own start phase.
//
// Debug (global): ?scenet=<s> forces the scene time at creation (it overrides
// start). Under ?freezetime (R19 checks, captures) 'random' becomes a fixed 0.37,
// so reloaded pages render the same moment.
import { FREEZE_TIME_S } from '../../debug-capture.js';

function urlParam(name) {
  if (typeof location === 'undefined') return null;
  return new URLSearchParams(location.search).get(name);
}

export class SceneClock {
  constructor(opts = {}) {
    this.period = opts.period > 0 ? opts.period : 40;
    let phase;
    if (opts.start === 'random' || opts.start == null) phase = FREEZE_TIME_S != null ? 0.37 : Math.random();
    else phase = ((Number(opts.start) % 1) + 1) % 1;
    let e = phase * this.period;
    const forced = parseFloat(urlParam('scenet'));
    if (Number.isFinite(forced) && forced >= 0) e = forced;
    this._e0 = e;
    this.elapsed = e;
    this.cycle = 0;
    this.t = e % this.period;
    this.phase = this.t / this.period;
    this.wrapped = false;
    this._base = Math.floor(e / this.period);
  }

  update(dt) {
    this.wrapped = false;
    if (!(dt > 0)) return this;
    this.elapsed += dt;
    const k = Math.floor(this.elapsed / this.period);
    if (k > this._base + this.cycle) { this.cycle = k - this._base; this.wrapped = true; }
    this.t = this.elapsed - k * this.period;
    this.phase = this.t / this.period;
    return this;
  }

  // restart a cycle now, at phase p (a debug trigger, a track change)
  restart(p = 0) {
    this.elapsed = (this._base + this.cycle + 1) * this.period + p * this.period;
    this.cycle++;
    this.t = p * this.period;
    this.phase = p;
    this.wrapped = true;
    return this;
  }
}
